import { AnimationCube } from './AnimationCube';
import { UploadingOverlay } from './UploadingOverlay';

const CUBE_DELAYS = ['0.2s', '0.3s', '0.4s', '0.1s', '0.2s', '0.3s', '0s', '0.1s', '0.2s'];

interface DropzoneUploadingOverlayProps {
  isUploading: boolean;
}

export const DropzoneUploadingOverlay = ({ isUploading }: DropzoneUploadingOverlayProps) => (
  <UploadingOverlay isUploading={isUploading}>
    <div className="my-8 h-10 w-10">
      {CUBE_DELAYS.map((delay, i) => (
        <AnimationCube key={i} animationDelay={delay} />
      ))}
    </div>
    <div>Uploading...</div>
  </UploadingOverlay>
);
